import { Component } from '@angular/core';
import {UsuarioService} from "../../../modules/auth/services/usuario-service";
import {UsuarioInformacoes} from "../../models/usuario-informacoes";
import Swal from "sweetalert2";

@Component({
    selector: 'app-tutorial',
    templateUrl: './tutorial.component.html',
    styleUrl: './tutorial.component.css',
    standalone: false
})
export class TutorialComponent {
  usuarioInformacoes = new UsuarioInformacoes();
  ultimaPagina = false;
  primeiraPagina = true;
  segundaPagina = false;
  terceiraPagina = false;
  quartaPagina = false;
  quintaPagina = false;
  sextaPagina = false;

  cont = 1;

  constructor(private usuarioService: UsuarioService) {
    this.buscarInformacoes();
  }

  irAnterior(){
    if(this.cont > 1){
      this.cont--;
      this.trocarPagina();
    }
  }

  irProximo(){
    this.cont++;
    if(this.cont <= 7){
      this.trocarPagina();
    }
  }

  private trocarPagina(){
    switch (this.cont){
      case 1:
      {
        this.primeiraPagina = true;
        this.segundaPagina = false;
        this.terceiraPagina = false;
        this.quartaPagina = false;
        this.quintaPagina = false;
        this.sextaPagina = false;
        this.ultimaPagina = false;
        break;
      }
      case 2:
      {
        this.primeiraPagina = false;
        this.segundaPagina = true;
        this.terceiraPagina = false;
        this.quartaPagina = false;
        this.quintaPagina = false;
        this.sextaPagina = false;
        this.ultimaPagina = false;
        break;
      }
      case 3:
      {
        this.primeiraPagina = false;
        this.segundaPagina = false;
        this.terceiraPagina = true;
        this.quartaPagina = false;
        this.quintaPagina = false;
        this.sextaPagina = false;
        this.ultimaPagina = false;
        break;
      }
      case 4:
      {
        this.primeiraPagina = false;
        this.segundaPagina = false;
        this.terceiraPagina = false;
        this.quartaPagina = true;
        this.quintaPagina = false;
        this.sextaPagina = false;
        this.ultimaPagina = false;
        break;
      }
      case 5:
      {
        this.primeiraPagina = false;
        this.segundaPagina = false;
        this.terceiraPagina = false;
        this.quartaPagina = false;
        this.quintaPagina = true;
        this.sextaPagina = false;
        this.ultimaPagina = false;
        break;
      }
      case 6:
      {
        this.primeiraPagina = false;
        this.segundaPagina = false;
        this.terceiraPagina = false;
        this.quartaPagina = false;
        this.quintaPagina = false;
        this.sextaPagina = true;
        this.ultimaPagina = false;
        break;
      }
      case 7:
      {
        this.primeiraPagina = false;
        this.segundaPagina = false;
        this.terceiraPagina = false;
        this.quartaPagina = false;
        this.quintaPagina = false;
        this.sextaPagina = false;
        this.ultimaPagina = true;
        break;
      }
      default:{
        this.primeiraPagina = true;
        this.segundaPagina = false;
        this.terceiraPagina = false;
        this.quartaPagina = false;
        this.quintaPagina = false;
        this.sextaPagina = false;
        this.ultimaPagina = false;
        break;
      }
    }
  }

  pularTutorial(): void {
    Swal.fire({
      title: 'Deseja realmente pular o tutorial?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed)
        this.encerrarTutorial();
    });
  }

  encerrarTutorial(): void {
    this.usuarioService.encerrarTutorial().subscribe(resultado =>{
      if(resultado.sucesso)
        this.buscarInformacoes();
    });
  }

  private buscarInformacoes(){
    this.usuarioService.buscarInformacoes().subscribe(resultado => {
      if(resultado.sucesso){
        this.usuarioInformacoes = resultado.dados;
      }
    });
  }
}
